import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getItemTypeList, getAllRouteDetails, getRateUnits, rateCardValidity } from './rateCard/rateCardAPIs';
import { addPaymentDetails, getAllState, getAllDistrict, getAllRevenueCircle, getCategoryList, getPaymentMethodList, getPaymentCycleList, getPaymentUrnsList } from './resourceCommonAPIs';
import { CATEGORY_ERROR, ITEM_TYPE_ERROR, STATE_ERROR, DISTRICT_ERROR, REVENUE_CIRCLE_ERROR, ROUTE_TYPE_ERROR, UNIT_PER_ERROR, CREATE_RATE_CARD, STAKEHOLDER_URN, STAKEHOLDER_NAME, REGISTRATION_NO, VEHICLE_TYPE, VEHICLE_CAPACITY, VEHICLE_MAKE, VEHICLE_MODEL, ROUTE, LAND_NAME, ITEM_RATE, SUBMIT, CATEGORY, ITEM_TYPE, ROUTE_TYPE, STATE, DISTRICT, REVENUE_CIRCLE, UNIT_PER, ITEM_RATE_MASS_ENTRY, INSERT_ALL, NO_DATA_AVAILABLE, PROCEED, FILE_NAME_VALIDATION_ERROR } from '../../common/constants';
import { handleNumberFieldFocus, titleCase } from '../../common/commonFunction';
import { Button, CardContent, Divider } from '@mui/material';
import { PROD } from '../../common/constants';
import { Container, Card, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DataGrid, GridEditInputCell, useGridApiContext } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import BackButton from '../../common/backButton';
import { DEMAND_VALIDATIONS, VALIDATION, VehicleValidation, fileNameValidation, openTextFieldValidation, validateAmount } from '../../common/commonValidations';
import { v4 as uuidv4 } from 'uuid';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { DistrictChangePopover } from "./rateCard/districtChangePopover";
import { ProceedIcon, SubmitIcon } from "../../common/icons";

function PaymentDetails() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [categoryList, setCategoryList] = useState();
    const [itemTypeList, setItemTypeList] = useState();
    const [showData, setShowData] = useState(false);
    const [onChangeFlag, setOnChangeFlag] = useState(false);
    const [urnsList, setUrnsList] = useState([]);
    const [paymentDetailsList, setPaymentDetailsList] = useState([]);
    const [routesList, setRoutesList] = useState();
    const [chooseState, setchooseState] = useState([]);
    const [chooseDistrict, setChooseDistrict] = useState([]);
    const [chooseRevenueCircle, setChooseRevenueCircle] = useState([]);
    const [unitsList, setUnitsList] = useState([]);
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
    const [distrcitLogModalOpen, setDistrcitLogModalOpen] = useState(false);
    const handleDistrictLogModalOpen = () => setDistrcitLogModalOpen(true);
    const handleDistrictLogModalClose = () => setDistrcitLogModalOpen(false);
    const [addedResponse, setAddedResponse] = useState();
    const [paymentDetails, setPaymentDetails] = useState(
        {
            category: null,
            advancePaymentPercent: null,
            paymentCycle: null,
            loyaltyPaymentPercent: null,
            deliveryTolerance: null,
            state: null,
            district: null,
            revenueCircle: null,
        }
    );

    const [errorMessage, setErrorMessage] = useState({
        categoryError: '',
        stateError: '',
        districtError: '',
        advancePaymentError: '',
        paymentPercentError: '',
        deliveryToleranceError: ''
    });
    const [paymentDetailsArr, setPaymentDetailsArr] = useState([]);
    const [paymentMethodList, setPaymentMethodList] = useState([])
    const [paymentCycleList, setPaymentCycleList] = useState([]);
    console.log("paymentDetailsArr", paymentDetailsArr)

    useEffect(() => {
        getCategoryList(setCategoryList);
        getAllRouteDetails(setRoutesList);
        getAllState(setchooseState);
        // getPaymentMethodList(setPaymentMethodList);
        getPaymentCycleList(setPaymentCycleList);
    }, []);

    useEffect(() => {
        if (paymentDetailsList && urnsList && onChangeFlag) {
            let arrayData = []
            urnsList?.map((item) => {
                if (paymentDetails?.category === "Grower") {
                    item?.landDtlList?.map((landDtlList) => arrayData.push({
                        id: paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.id ? paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.id : uuidv4(),
                        category: paymentDetails?.category,
                        urnNumber: item?.urn,
                        name: item?.name,
                        state: landDtlList?.state,
                        district: landDtlList?.district,
                        revenueCircle: landDtlList?.revenueCircle,
                        landId: landDtlList?.landId,
                        landName: landDtlList?.landName,
                        advancePaymentPercent: paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.advancePaymentPercent,
                        paymentCycle: paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.paymentCycle,
                        loyaltyPaymentPercent: paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.loyaltyPaymentPercent,
                        deliveryTolerance: paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.deliveryTolerance,
                    }))
                }
                else {
                    arrayData.push({
                        id: paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.id ? paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.id : uuidv4(),
                        category: paymentDetails?.category,
                        urnNumber: item?.urn,
                        name: item?.name,
                        state: item?.state,
                        district: item?.district,
                        revenueCircle: item?.revenueCircle,
                        landId: null,
                        landName: null,
                        advancePaymentPercent: paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.advancePaymentPercent,
                        paymentCycle: paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.paymentCycle,
                        loyaltyPaymentPercent: paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.loyaltyPaymentPercent,
                        deliveryTolerance: paymentDetailsList.find((paymentDetailsItem) => paymentDetailsItem.stakeholderUrn === item.urn)?.deliveryTolerance,
                    })
                }
            }
            )
            setPaymentDetailsArr(arrayData.sort((a, b) => {
                if (a.advancePaymentPercent === undefined) return -1; // Move undefined to end
                if (b.advancePaymentPercent === undefined) return 1; // Move undefined to end
                return 0; // No change in order for defined paymentMethods
            }))

        }
    }, [paymentDetailsList]);

    const onConfirmSubmit = () => {
        handleConfirmLogModalClose();
        const finalArray = []
        const changedObjects = paymentDetailsArr.filter((item) => item.advancePaymentPercent !== paymentDetailsList.find((paymentItem) => paymentItem.stakeholderUrn === item.urnNumber)?.advancePaymentPercent || item.paymentCycle !== paymentDetailsList.find((paymentItem) => paymentItem.stakeholderUrn === item.urnNumber)?.paymentCycle || item.loyaltyPaymentPercent !== paymentDetailsList.find((paymentItem) => paymentItem.stakeholderUrn === item.urnNumber)?.loyaltyPaymentPercent || item.deliveryTolerance !== paymentDetailsList.find((paymentItem) => paymentItem.stakeholderUrn === item.urnNumber)?.deliveryTolerance);
        changedObjects.forEach((item) => finalArray.push({
            id: item.id,
            stakeholderUrn: item.urnNumber,
            stakeholderType: item.category,
            growerLandId: item.landId,
            advancePaymentPercent: item.advancePaymentPercent,
            loyaltyPaymentPercent: item.loyaltyPaymentPercent,
            paymentCycle: item.paymentCycle,
            deliveryTolerance: item.deliveryTolerance
        }));
        addPaymentDetails(finalArray, setAddedResponse);
    }

    const onSubmit = (e) => {
        const changedObjects = paymentDetailsArr.filter((item) => item.advancePaymentPercent !== paymentDetailsList.find((paymentItem) => paymentItem.stakeholderUrn === item.urnNumber)?.advancePaymentPercent || item.paymentCycle !== paymentDetailsList.find((paymentItem) => paymentItem.stakeholderUrn === item.urnNumber)?.paymentCycle || item.loyaltyPaymentPercent !== paymentDetailsList.find((paymentItem) => paymentItem.stakeholderUrn === item.urnNumber)?.loyaltyPaymentPercent || item.deliveryTolerance !== paymentDetailsList.find((paymentItem) => paymentItem.stakeholderUrn === item.urnNumber)?.deliveryTolerance);
        // console.log("changedObjects", changedObjects)
        changedObjects.some((item) => {
            if (!item.paymentCycle) {
                toast.error('Please Select Payment Cycle')
            }
            else if (!item.deliveryTolerance) {
                toast.error('Please fill Delivery Tolerance')
            }
            else {
                handleConfirmLogModalOpen();
            }
        })
        // if (changedObjects.some((item) => !item.advancePaymentPercent || !item.paymentCycle || (item.advancePaymentPercent !== "Regular" && !item.loyaltyPaymentPercent))) {
        //     toast.error('Please fill all details')
        // }
        // else {
        //     handleConfirmLogModalOpen();
        // }
    };

    const onProceed = (e) => {
        e.preventDefault();
        if (!paymentDetails?.category) {
            setErrorMessage({ ...errorMessage, categoryError: CATEGORY_ERROR });
        }
        else if (!paymentDetails?.state && paymentDetails?.category === "Grower") {
            setErrorMessage({ ...errorMessage, stateError: STATE_ERROR });
        }
        else if (!paymentDetails?.district && paymentDetails?.category === "Grower") {
            setErrorMessage({ ...errorMessage, districtError: DISTRICT_ERROR });
        }
        else {
            getPaymentUrnsList(setUrnsList, paymentDetails, setPaymentDetailsList);
            setShowData(true);
        }
    }

    const onInsertAll = () => {
        if (!errorMessage.paymentPercentError && !errorMessage.deliveryToleranceError) {
            const tempArr = ((paymentDetailsArr).map(paymentDetailsArrItem => {
                paymentDetailsArrItem.advancePaymentPercent = paymentDetails?.advancePaymentPercent
                paymentDetailsArrItem.paymentCycle = paymentDetails?.paymentCycle
                paymentDetailsArrItem.loyaltyPaymentPercent = paymentDetails?.loyaltyPaymentPercent
                paymentDetailsArrItem.deliveryTolerance = paymentDetails?.deliveryTolerance
                return paymentDetailsArrItem
            }
            ))
            setPaymentDetailsArr(tempArr);
        }
    }

    const [tempDistrict, setTempDistrict] = useState("")

    const handleChange = (e) => {
        setOnChangeFlag(true);
        if (e.target.name === "category") {
            setPaymentDetails({ ...paymentDetails, category: e.target.value })
            setErrorMessage({ ...errorMessage, categoryError: "" });
        }
        if (e.target.name === "itemType") {
            setPaymentDetails({ ...paymentDetails, itemType: e.target.value })
            setErrorMessage({ ...errorMessage, itemTypeError: "" });
        }
        if (e.target.name === "state") {
            getAllDistrict(e.target.value, setChooseDistrict);
            setPaymentDetails({ ...paymentDetails, state: e.target.value })
            setErrorMessage({ ...errorMessage, stateError: "" });
        }
        if (e.target.name === "district") {
            setTempDistrict(e.target.value)
            if (paymentDetailsArr.length !== 0) {
                handleDistrictLogModalOpen();
            }
            else {
                getAllRevenueCircle(e.target.value, setChooseRevenueCircle);
                setPaymentDetails({ ...paymentDetails, district: e.target.value })
                setErrorMessage({ ...errorMessage, districtError: "" });
            }
        }
        if (e.target.name === "revenueCircle") {
            setPaymentDetails({ ...paymentDetails, revenueCircle: e.target.value })
        }
        if (e.target.name === "routeType") {
            setPaymentDetails({ ...paymentDetails, routeType: e.target.value })
            setErrorMessage({ ...errorMessage, routeTypeError: "" });
        }
        if (e.target.name === "advancePaymentPercent") {
            setPaymentDetails({ ...paymentDetails, advancePaymentPercent: e.target.value })
            if (DEMAND_VALIDATIONS.paymentValidation(e.target.value, 8, 2)) {
                setErrorMessage({ ...errorMessage, advancePaymentError: DEMAND_VALIDATIONS.paymentValidation(e.target.value, 8, 2) })
            }
            else {
                setErrorMessage({ ...errorMessage, advancePaymentError: '' })
            }
            // if (e.target.value === "Regular") {
            //     setPaymentDetails({ ...paymentDetails, advancePaymentPercent: openTextFieldValidation(e.target.value.slice(0, 50)), loyaltyPaymentPercent: "" })
            // }
            // else setPaymentDetails({ ...paymentDetails, advancePaymentPercent: openTextFieldValidation(e.target.value.slice(0, 50)) })
        }
        if (e.target.name === "paymentCycle") {
            setPaymentDetails({ ...paymentDetails, paymentCycle: e.target.value })
        }
        if (e.target.name === "loyaltyPaymentPercent") {
            setPaymentDetails({ ...paymentDetails, loyaltyPaymentPercent: e.target.value })
            if (DEMAND_VALIDATIONS.paymentValidation(e.target.value, 8, 2)) {
                setErrorMessage({ ...errorMessage, paymentPercentError: DEMAND_VALIDATIONS.paymentValidation(e.target.value, 8, 2) })
            }
            else {
                setErrorMessage({ ...errorMessage, paymentPercentError: '' })
            }
        }
        if (e.target.name === "deliveryTolerance") {
            setPaymentDetails({ ...paymentDetails, deliveryTolerance: e.target.value })
            if (DEMAND_VALIDATIONS.paymentValidation(e.target.value, 8, 2)) {
                setErrorMessage({ ...errorMessage, deliveryToleranceError: DEMAND_VALIDATIONS.paymentValidation(e.target.value, 8, 2) })
            }
            else {
                setErrorMessage({ ...errorMessage, deliveryToleranceError: '' })
            }
        }
    }

    useEffect(() => {
        if (onChangeFlag) {
            setPaymentDetails({
                ...paymentDetails,
                advancePaymentPercent: null,
                paymentCycle: null,
                loyaltyPaymentPercent: null,
                deliveryTolerance: null,
                state: null,
                district: null,
                revenueCircle: null
            });
            setPaymentDetailsArr([]);
            setShowData(false);
            setUrnsList();
            setChooseDistrict([]);
            setErrorMessage({ ...errorMessage, advancePaymentError: '', paymentPercentError: '', deliveryToleranceError: '' })
        }
    }, [paymentDetails.category]);

    useEffect(() => {
        if (onChangeFlag) {
            setPaymentDetailsArr([]);
            setShowData(false);
            setUrnsList();
            setErrorMessage({ ...errorMessage, advancePaymentError: '', paymentPercentError: '', deliveryToleranceError: '' })
        }
    }, [paymentDetails.revenueCircle]);

    useEffect(() => {
        if (onChangeFlag) {
            setPaymentDetails({
                ...paymentDetails,
                district: null,
                revenueCircle: null
            });
            setShowData(false);
            setUrnsList();
        }
    }, [paymentDetails.state]);

    useEffect(() => {
        if (onChangeFlag) {
            setPaymentDetails({
                ...paymentDetails,
                revenueCircle: null
            });
            setShowData(false);
            setUrnsList();
        }
    }, [paymentDetails.district]);

    function onCancelBack() {
        handleDistrictLogModalClose();
    }

    function onConfirmCallBack() {
        handleDistrictLogModalClose();
        getAllRevenueCircle(tempDistrict, setChooseRevenueCircle);
        setPaymentDetails({ ...paymentDetails, district: tempDistrict })
        setErrorMessage({ ...errorMessage, districtError: "" });
    }

    

    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        },
    }));

      function EditInputCell(props) {
            const { error, id, value: valueProp, field } = props;
            const [value, setValue] = useState(valueProp);
            const apiRef = useGridApiContext();
    
            const handleChange = (event) => {
                const newValue = event.target.value; 
                apiRef.current.setEditCellValue({ id, field, value: newValue });
                setValue(newValue);
            };
    
            useEffect(() => {
                setValue(valueProp);
            }, [valueProp]);
            
            return (
                <StyledTooltip open={!!error} title={error}>
                    <GridEditInputCell {...props} value={value} onFocus={handleNumberFieldFocus} onChange={handleChange} onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}/>
               </StyledTooltip>
            );
        }

    function renderEdit(params) {
        return <EditInputCell {...params} />;
    }

    const processRowUpdate = (newRow) => {
        paymentDetailsArr.forEach((item) => {
            if (item.id === newRow.id) {
                item.advancePaymentPercent = newRow.advancePaymentPercent
                item.paymentCycle = newRow.paymentCycle
                item.loyaltyPaymentPercent = newRow.loyaltyPaymentPercent
                item.deliveryTolerance = newRow.deliveryTolerance
            }
        })
        return newRow
    };

    const columns = [
        { field: 'urnNumber', headerName: STAKEHOLDER_URN, width: 160 },
        { field: 'name', headerName: STAKEHOLDER_NAME, width: 160 },
        {
            field: 'state', headerName: STATE, width: 160, hide: paymentDetails?.category !== "LLE",
            renderCell: (params) => {
                return (
                    params?.row?.state && titleCase(params?.row?.state)
                )
            }
        },
        {
            field: 'district', headerName: DISTRICT, width: 160, hide: paymentDetails?.category !== "LLE",
            renderCell: (params) => {
                return (
                    params?.row?.district && titleCase(params?.row?.district)
                )
            }
        },
        { field: 'landName', headerName: LAND_NAME, width: 160, hide: !(paymentDetails?.category === "Grower" && paymentDetails?.itemType === "Bamboo Rate") },
        {
            field: 'advancePaymentPercent', headerName: "Advance Payment %", type: 'number', width: 160, editable: true,
            preProcessEditCellProps: (params) => {
                console.log("params", params)
                return { ...params.props, error: DEMAND_VALIDATIONS.paymentValidation(params.props.value, 8, 2) };
            },
            renderEditCell: renderEdit,
            // renderEditCell: (params) => {
            //     return (<FormControl sx={{ width: '100%' }} size="small" variant="standard">
            //         <Select
            //             value={params?.value}
            // onChange={(e) => {
            //     params.api.setEditCellValue({
            //         id: params.id,
            //         field: params.field,
            //         value: e.target.value,
            //     });
            // }}
            //         >
            //             {/* <MenuItem value=null><em>--Select--</em></MenuItem> */}
            //             {
            //                 paymentMethodList?.map((item) =>
            //                     <MenuItem value={item}>{item}</MenuItem>)
            //             }
            //         </Select>
            //     </FormControl>
            //     )
            // }
        },
        {
            field: 'loyaltyPaymentPercent', headerName: "Royalty Payment %", width: 160, type: 'number', editable: true,
            preProcessEditCellProps: (params) => {
                return { ...params?.props, error: DEMAND_VALIDATIONS.paymentValidation(params?.props?.value, 8, 2) };
            },
            renderEditCell: renderEdit,
            // renderEditCell: (params) => {
            //     if (!params.row.advancePaymentPercent) {
            //         return (<Tooltip title="Select payment Method"><Typography variant="body2" gutterBottom>
            //             NA
            //         </Typography></Tooltip>)
            //     }
            //     else if (params.row.advancePaymentPercent === 'Regular') {
            //         return (<Tooltip title="Payment % is not applicable for Regular Payment Method"><Typography variant="body2" gutterBottom>
            //             NA
            //         </Typography></Tooltip>)
            //     }
            //     else {
            //         return renderEdit(params)
            //     }
            // }
        },
        {
            field: 'paymentCycle', headerName: "Payment Cycle", width: 160, editable: true,
            renderEditCell: (params) => {
                return (<FormControl sx={{ width: '100%' }} size="small" variant="standard">
                    <Select
                        value={params?.value}
                        onChange={(e) => {
                            params.api.setEditCellValue({
                                id: params.id,
                                field: params.field,
                                value: e.target.value,
                            });
                        }}
                    >
                        {/* <MenuItem value=null><em>--Select--</em></MenuItem> */}
                        {
                            paymentCycleList?.map((item) =>
                                <MenuItem value={item}>{item}</MenuItem>)
                        }
                    </Select>
                </FormControl>
                )
            }
        },

        {
            field: 'deliveryTolerance', headerName: "Delivery Tolerance %", width: 160, type: 'number', editable: true,
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: DEMAND_VALIDATIONS.paymentValidation(params.props.value, 8, 2) };
            },
            renderEditCell: renderEdit,
        }
    ];

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p className='pageNumberingResc'>RES16</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} />
                    <Typography variant="h5" gutterBottom>
                        Payment Details
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={paymentDetails?.category === "Grower" ? 2 : 3}>
                                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={errorMessage.categoryError}>
                                    <InputLabel id="selectstakeholder-label">{CATEGORY}</InputLabel>
                                    <Select
                                        label={CATEGORY}
                                        name="category" value={paymentDetails?.category || ''} onChange={(e) => handleChange(e)}>
                                        <MenuItem><em>{CATEGORY}</em></MenuItem>
                                        {
                                            categoryList?.filter((item) => item !== "ABEPL Plant" || item !== "InterimStorageOperator")?.map((item) =>
                                                <MenuItem value={item}>{item}</MenuItem>)
                                        }
                                    </Select>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage?.categoryError}</FormHelperText>
                                </FormControl>
                            </Grid>
                            {paymentDetails?.category === "Grower" &&
                                <>
                                    <Grid item xs={12} lg={2}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={errorMessage?.stateError}>
                                            <InputLabel id="mappedstakeholder-label">{STATE}</InputLabel>
                                            <Select
                                                label={STATE}
                                                name="state" value={paymentDetails?.state || ''} onChange={(e) => handleChange(e)}>
                                                <MenuItem><em>{STATE}</em></MenuItem>
                                                {
                                                    chooseState?.map((statename) =>
                                                        <MenuItem value={statename}>{statename && titleCase(statename)}</MenuItem>)
                                                }
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage?.stateError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={errorMessage?.districtError}>
                                            <InputLabel id="mappedstakeholder-label">{DISTRICT}</InputLabel>
                                            <Select
                                                label={DISTRICT}
                                                name='district' value={paymentDetails?.district || ''} onChange={(e) => handleChange(e)}>
                                                <MenuItem><em>{DISTRICT}</em></MenuItem>
                                                {
                                                    chooseDistrict?.map((districtname) =>
                                                        <MenuItem value={districtname}>{districtname && titleCase(districtname)}</MenuItem>)
                                                }
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage?.districtError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                            <InputLabel id="mappedstakeholder-label">{REVENUE_CIRCLE}</InputLabel>
                                            <Select
                                                label={REVENUE_CIRCLE}
                                                name='revenueCircle' value={paymentDetails?.revenueCircle || ''} onChange={(e) => handleChange(e)}>
                                                <MenuItem><em>Select</em></MenuItem>
                                                {
                                                    chooseRevenueCircle?.map((revenueCirclename) =>
                                                        <MenuItem value={revenueCirclename}>{titleCase(revenueCirclename)}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </>}
                            <Grid item xs={12} lg={2}>
                                <Button endIcon={<ProceedIcon />} sx={{ minWidth: 100 }} className="RescProceed" variant="contained" onClick={(e) => onProceed(e)}>{PROCEED}</Button>
                            </Grid>
                        </Grid>
                        <Divider sx={{ my: 0.5 }} />
                        <Grid container spacing={1} sx={{ mt: 1 }}>
                            {showData &&
                                <> <Grid item xs={12} lg={3}>
                                    {/* <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                        <InputLabel id="selectstakeholder-label">Payment Method</InputLabel>
                                        <Select
                                            label="Payment Method"
                                            name="advancePaymentPercent" value={paymentDetails?.advancePaymentPercent || ''} onChange={(e) => handleChange(e)}>
                                            <MenuItem><em>Payment Method</em></MenuItem>
                                            {
                                                paymentMethodList?.map((item) =>
                                                    <MenuItem value={item}>{item}</MenuItem>)
                                            }
                                        </Select>
                                    </FormControl> */}
                                    <TextField fullWidth
                                        error={errorMessage.advancePaymentError}
                                        helperText={errorMessage.advancePaymentError}
                                        label="Advance Payment %"
                                        type="number"
                                        name="advancePaymentPercent"
                                        onFocus={handleNumberFieldFocus}
                                        value={paymentDetails?.advancePaymentPercent || ''}
                                        onChange={(e) => handleChange(e)}
                                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                        sx={{ paddingRight: '3%' }}
                                    />
                                </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <TextField fullWidth
                                            error={errorMessage.paymentPercentError}
                                            helperText={errorMessage.paymentPercentError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label="Royalty Payment %"
                                            name="loyaltyPaymentPercent"
                                            disabled={paymentDetails.advancePaymentPercent === "Regular"}
                                            value={paymentDetails?.loyaltyPaymentPercent || ''}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                            sx={{ paddingRight: '3%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                            <InputLabel id="selectstakeholder-label">Payment Cycle</InputLabel>
                                            <Select
                                                label="Payment Cycle"
                                                name="paymentCycle" value={paymentDetails?.paymentCycle || ''} onChange={(e) => handleChange(e)}>
                                                <MenuItem><em>Payment Cycle</em></MenuItem>
                                                {
                                                    paymentCycleList?.map((item) =>
                                                        <MenuItem value={item}>{item}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} lg={3}>
                                        <TextField fullWidth
                                            error={errorMessage.deliveryToleranceError}
                                            helperText={errorMessage.deliveryToleranceError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label="Delivery Tolerance %"
                                            name="deliveryTolerance"
                                            value={paymentDetails?.deliveryTolerance || ''}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                            sx={{ paddingRight: '3%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} mr={2} style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <p className="insert-button" onClick={() => onInsertAll()}>{INSERT_ALL}</p>
                                    </Grid>
                                </>}
                        </Grid>
                        {urnsList && showData ?
                            <Box mb={2} mt={2} sx={{
                                '& .super-app-theme--header': {
                                    wordWrap: 'break-word',
                                    wordBreak: 'break-all',
                                    whiteSpace: 'initial',
                                },
                                '& .MuiDataGrid-cell--editable': {
                                    bgcolor: (theme) =>
                                        theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                                },
                                '& .super-app.confirmationStatusPending': {
                                    backgroundColor: '#FFFF8F',
                                    color: '#1a3e72',
                                    fontWeight: '600',
                                },
                                '& .super-app.confirmationStatusRejected': {
                                    backgroundColor: '#F88379',
                                    color: '#1a3e72',
                                    fontWeight: '600',
                                },
                                '& .super-app.confirmationStatusConfirmed': {
                                    backgroundColor: '#ECFFDC',
                                    color: 'green',
                                    fontWeight: '600',
                                },
                                '& .MuiDataGrid-cell--editing': {
                                    backgroundColor: 'rgb(255,215,115, 0.19)',
                                    color: '#1a3e72',
                                    '& .MuiInputBase-root': {
                                        height: '100%',
                                    },
                                },
                                '& .Mui-error': {
                                    backgroundColor: 'pink',
                                    color: 'red',
                                },
                            }}>
                               
                                <DataGrid
                                    autoHeight
                                    rows={paymentDetailsArr}
                                    columns={columns}
                                    pageSize={10}
                                    experimentalFeatures={{ newEditingApi: true }}
                                    processRowUpdate={(e) => processRowUpdate(e)}
                                    components={{
                                        Toolbar: CustomDataGridToolbar,
                                    }}
                                    componentsProps={{ toolbar: { rows: paymentDetailsArr, columns: columns, fileName: "PaymentDetails.xlsx", name: "Export" } }}
                                />
                                
                            </Box>
                            :
                            <></>
                        }
                        <Grid item xs={12} lg={12} display='flex' justifyContent="flex-end">
                            {urnsList && showData &&
                                <Button endIcon={<SubmitIcon />} sx={{ minWidth: 100, mt: 2 }} variant="contained" onClick={(e) => onSubmit(e)} >Submit</Button>
                            }
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
            <DistrictChangePopover onOpen={distrcitLogModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} />
            <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} action="Submit" />
        </>
    );
}
export default PaymentDetails;
